import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import { PlatformUser } from '../models/api.models';

const ME_BASE = environment.apiBaseUrl + '/v1/admin/me';

/** Self-service profile + avatar client for the authenticated caller; password changes use the Keycloak `kc_action` redirect. */
@Injectable({ providedIn: 'root' })
export class ProfileService {
  private readonly http = inject(HttpClient);

  /** GET /me/profile - the caller's own projection (avatar, names, status). */
  getProfile(): Observable<PlatformUser> {
    return this.http.get<PlatformUser>(`${ME_BASE}/profile`);
  }

  /** PATCH /me/profile - updates first/last name (Keycloak + projection). */
  patchNames(firstName: string, lastName: string): Observable<PlatformUser> {
    return this.http.patch<PlatformUser>(`${ME_BASE}/profile`, {
      first_name: firstName,
      last_name: lastName,
    });
  }

  /** POST /me/avatar - multipart upload (field `file`); returns the public URL. */
  uploadAvatar(file: File): Observable<{ avatar_url: string }> {
    const form = new FormData();
    form.append('file', file);
    return this.http.post<{ avatar_url: string }>(`${ME_BASE}/avatar`, form);
  }

  /** DELETE /me/avatar - clears the caller's avatar. */
  deleteAvatar(): Observable<void> {
    return this.http.delete<void>(`${ME_BASE}/avatar`);
  }

  /** POST /me/password; 400 carries `{ error: 'password_rejected', message }` on wrong/rejected password. */
  changePassword(currentPassword: string, newPassword: string, otpCode = ''): Observable<void> {
    return this.http.post<void>(`${ME_BASE}/password`, {
      current_password: currentPassword,
      new_password: newPassword,
      otp_code: otpCode,
    });
  }
}
